// extracted by mini-css-extract-plugin
export default {"carousel":"ComponentCarousel_carousel__r5p-D","btnPrev":"ComponentCarousel_btnPrev__-aCB6","btnNext":"ComponentCarousel_btnNext__dOwNd","img":"ComponentCarousel_img__CsJ7I"};